"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Popover = _interopRequireDefault(require("../Popover"));

var _styling = require("../../toolkit/styling");

var _icons = require("../../toolkit/icons");

var _string = require("../../toolkit/string");

var _device = require("../../toolkit/device");

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CopyButtonSize = 15;

var CopyButton = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CopyButton, _Component);

  var _super = _createSuper(CopyButton);

  function CopyButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, CopyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "mouseOver", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "justCopied", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onCopied", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onMouseLeave", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(CopyButton, [{
    key: "renderCopyButton",
    value: function renderCopyButton() {
      var _this$props = this.props,
          copyOnBodyClick = _this$props.copyOnBodyClick,
          promptProp = _this$props.prompt,
          popoverPosition = _this$props.popoverPosition;

      if (!this.copyButtonVisible) {
        // return a placeholder, so that the whole width of this
        // component will not change back and forth. It's especially
        // useful when an ObjectId is in a Table component
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: 15
          }
        });
      }

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      var prompt = promptProp || i18n("Copy");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.copyContainer),
        onClick: copyOnBodyClick ? undefined : this.onCopied
      }, /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        popoverContent: this.justCopied ? i18n("Copied!") : prompt,
        paddingContentPadding: "5px 10px",
        position: popoverPosition,
        popoverMinWidth: 48
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: this.justCopied ? _icons.copiedImage : _icons.copyImage,
        alt: "copy button",
        draggable: "false",
        className: (0, _styling.css)(this.justCopied ? this.styles.copiedButton : null),
        style: {
          width: CopyButtonSize
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          copyOnBodyClick = _this$props2.copyOnBodyClick,
          prompt = _this$props2.prompt,
          showFull = _this$props2.showFull,
          hideButtonUntilHover = _this$props2.hideButtonUntilHover,
          children = _this$props2.children,
          className = _this$props2.className,
          popoverPosition = _this$props2.popoverPosition,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["disabled", "copyOnBodyClick", "prompt", "showFull", "hideButtonUntilHover", "children", "className", "popoverPosition"]);

      if (!this.text) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        onClick: !disabled && copyOnBodyClick ? this.onCopied : undefined,
        onMouseEnter: function onMouseEnter() {
          return _this2.mouseOver = true;
        },
        onMouseLeave: this.onMouseLeave
      }, props, {
        className: (0, _styling.css)(this.styles.root, className)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content)
      }, children), this.text && !disabled && this.renderCopyButton());
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          copyOnBodyClick = _this$props3.copyOnBodyClick;
      var keyframes = {
        from: {
          transform: "scale3d(0, 0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale3d(1, 1, 1)",
          opacity: 1
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          cursor: disabled || !copyOnBodyClick ? "default" : "pointer",
          alignItems: "center",
          flexWrap: "nowrap"
        },
        copyButton: {
          marginLeft: 5,
          textTransform: "uppercase",
          fontSize: 10
        },
        content: {
          marginRight: 5,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        copyContainer: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          width: CopyButtonSize,
          height: CopyButtonSize,
          flexShrink: 0,
          background: "radial-gradient(circle at 100%, white, white " + "50%, white 25%, transparent 10%);"
        },
        copiedButton: {
          animationName: [keyframes],
          animationDuration: "250ms"
        }
      });
    }
  }, {
    key: "copyButtonVisible",
    get: function get() {
      var _DeviceStore$instance = _device.DeviceStore.instance(),
          isSmallScreen = _DeviceStore$instance.isSmallScreen;

      var mouseOver = this.mouseOver,
          hideButtonUntilHover = this.props.hideButtonUntilHover;

      if (isSmallScreen || !hideButtonUntilHover) {
        return true;
      }

      return mouseOver;
    }
  }, {
    key: "text",
    get: function get() {
      var _this$props4 = this.props,
          text = _this$props4.text,
          children = _this$props4.children;

      if (text != null) {
        return text;
      }

      if (typeof children == "string") {
        return children;
      }

      return null;
    }
  }]);
  return CopyButton;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {}, _class3.demoProps = {
  text: "COPIED TEXT"
}, _class3.defaultProps = {
  hideButtonUntilHover: true,
  popoverPosition: "top center"
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "mouseOver", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "justCopied", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onCopied", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (e) {
      var text = _this3.text;

      if (text == null) {
        return;
      }

      e.preventDefault();
      _this3.justCopied = true;
      (0, _string.copyToClipboard)(text);
      setTimeout(function () {
        _this3.justCopied = false;
      }, 5000);
    };
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onMouseLeave", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      _this4.mouseOver = false;
      _this4.justCopied = false;
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "copyButtonVisible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "copyButtonVisible"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "text", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "text"), _class2.prototype)), _class2)) || _class;

var _default = CopyButton;
exports["default"] = _default;